module.exports = __webpack_public_path__ + "static/media/ic sun.51c7de13.png";